import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ProductList from '../product/product-list/ProductList.tsx';
import { useUserContext } from '../user/context/UserContext.tsx';
import { isLogged } from '../utils/utils.ts';
import AuthLayout from './AuthLayout.tsx';
import Login from './Login.tsx';

const LoginScreen = () => {
  const navigate = useNavigate();
  const { userInfo } = useUserContext();

  useEffect(() => {
    if (userInfo) {
      navigate(`/`);
    }
  }, [userInfo, navigate]);

  return <AuthLayout>{isLogged() ? <ProductList /> : <Login />}</AuthLayout>;
};

export default LoginScreen;
